var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`StatusBadge StatusBadge--${_vm.status}`},[_vm._v(_vm._s(_vm.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }